const multiInputPinWrapperSelector = '.multi-input-pin';
const multiInputPinInputSelector = '.multi-input-pin__input';
const actualHiddenInputSelector = '#pin';

const initMultiInputPin = (submitBtnSelector = null, autoSubmit = false) => {

    const multiInputPinContainer = document.querySelector(multiInputPinWrapperSelector);
    if (!multiInputPinContainer) {
        return;
    }
    const inputBoxes = [...multiInputPinContainer.querySelectorAll(multiInputPinInputSelector)];

    //on load clear all inputs
    inputBoxes.forEach(input => input.value = '');

    const hiddenPinInput = document.querySelector(actualHiddenInputSelector);
    const focusFirstInput = () => {
        if (!inputBoxes.length) return;
        const active = document.activeElement;
        if (!active || active === document.body) {
            inputBoxes[0].focus();
        }
    };
    // Update hidden pin value from visible inputs
    const updateHiddenPin = () => {
        if (!hiddenPinInput) return;
        hiddenPinInput.value = inputBoxes.map(input => input.value).join('');
        if (!hiddenPinInput.value) {
            hiddenPinInput.value = '0'; //to avoid symfony validation issues
        }

        if (hiddenPinInput.value.length === inputBoxes.length && autoSubmit && submitBtnSelector) {
            const submitBtn = document.querySelector(submitBtnSelector);
            if (submitBtn) {
                //check if there is captcha and is already solved before enabling auto-submit
                const captchaInput = document.querySelector('[name="g-recaptcha-response"]');
                if (captchaInput && captchaInput.value) {
                    submitBtn.click();
                }
            }
        }
    };

    // Handle typing into inputs
    multiInputPinContainer.addEventListener('input', (event) => {
        const currentInput = event.target;
        const currentIndex = inputBoxes.indexOf(currentInput);
        if (currentIndex === -1) return;

        // Allow only one digit per input
        currentInput.value = (currentInput.value.match(/\d/) || [''])[0];

        // Move focus to next input if digit entered
        if (currentInput.value && currentIndex < inputBoxes.length - 1) {
            inputBoxes[currentIndex + 1].focus();
        }

        updateHiddenPin();
    });

    // Handle backspace navigation
    multiInputPinContainer.addEventListener('keydown', (event) => {
        if (event.key !== 'Backspace') return;

        const currentInput = event.target;
        const currentIndex = inputBoxes.indexOf(currentInput);
        if (currentIndex === -1) return;

        // If current input is empty, move focus back
        if (!currentInput.value && currentIndex > 0) {
            inputBoxes[currentIndex - 1].focus();
        }
    });

    // Handle paste code
    multiInputPinContainer.addEventListener('paste', (event) => {
        const currentInput = event.target;
        const startIndex = inputBoxes.indexOf(currentInput);
        if (startIndex === -1) return;

        const pastedDigits = (event.clipboardData?.getData('text') || '')
            .replace(/\D/g, '');

        if (!pastedDigits) return;

        event.preventDefault();

        pastedDigits
            .slice(0, inputBoxes.length - startIndex)
            .split('')
            .forEach((digit, offset) => {
                inputBoxes[startIndex + offset].value = digit;
            });

        const lastIndex = Math.min(
            startIndex + pastedDigits.length,
            inputBoxes.length
        ) - 1;

        inputBoxes[lastIndex].focus();
        updateHiddenPin();
    });

    updateHiddenPin();
    // Ensure first OTP input is focused on load for accessibility and tests
    focusFirstInput();


    //count down seconds from 2:00 to 0:00 until user can resend verification code
    let countdownInterval = null;
    const countdownElement = document.querySelector('#countdown');
    if (countdownElement) {
        let timeLeft = 119; // 2 minutes in seconds

        const updateCountdown = () => {
            const minutes = Math.floor(timeLeft / 60);
            const seconds = timeLeft % 60;
            countdownElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;

            if (timeLeft > 0) {
                timeLeft -= 1;
            } else {
                clearInterval(countdownInterval);

                const resendBtn = document.getElementById("resend_btn");
                if (resendBtn) {
                    resendBtn.classList.remove("disabled");
                    resendBtn.classList.add("link-primary");
                }
            }
        };

        updateCountdown(); // Initialize immediately
        countdownInterval = setInterval(updateCountdown, 1000);
    }
}

export default initMultiInputPin;